export class WorkOrderReferencesResultDto {
    referenceId: string;
    reference: string;
    // It used to bind the Reference column value to respective column based on the type.
    // P or M - Property Address
    // A - Amenity
    // B - Area
    // C - Description

    description: string;
    // It used to bind the Description column value to respective column based on the type.
    // P or M - Owner
    // A - Description
    // B - Hide column
    // C - StreetNumber

    attribute: string;
    // It used to bind the Attribute column value to respective column based on the type.
    // P or M - CustomerID
    // A - Address
    // B - Attribute
    // C - Street Name
}
